import { SubscriptionSessionPackUsageHistoryDTOStatus } from "@gymflow/types";
import { useTranslation } from "react-i18next";

import { DotBadge, DotBadgeProps } from "../../DotBadge";

type UsageItemStatusProps = {
  status: SubscriptionSessionPackUsageHistoryDTOStatus;
};

const COLOR_MAP: Record<
  SubscriptionSessionPackUsageHistoryDTOStatus,
  DotBadgeProps["intent"]
> = {
  ATTENDED: "success",
  BOOKED: "lightblue",
  NO_SHOW: "gray",
  WAITING: "gray",
  CANCELLED: "warning",
  LATE_CANCELLED: "warning",
  CONFIRMED: "success",
};

export const UsageItemStatus = ({ status }: UsageItemStatusProps) => {
  const { t } = useTranslation();

  return (
    <DotBadge intent={COLOR_MAP[status]} size="xs">
      {t(`common.attendanceStatus.${status}`)}
    </DotBadge>
  );
};
